export const JSON_PATH = './assets/config/admin/json';
export const IMAGE_PATH = './assets/config/admin/image';
export const PDF_PATH = './assets/config/admin/pdf';

export const DEFAULT_JSON_PATH = {
  casinoSystemType: `${JSON_PATH}/casino-system-type-fields.json`,
  languageLocals: `${JSON_PATH}/language-locals.json`,
  currency: `${JSON_PATH}/currency.json`,
  zone: `${JSON_PATH}/zone.json`,
  digitalKeyLocation: `${JSON_PATH}/digitalkey-location.json`,
  countryCode: `${JSON_PATH}/country-code.json`,
  payDetails: `${JSON_PATH}/pay-details.json`,
  addressConfig: `${JSON_PATH}/address-config.json`,
  spaCredential: `${JSON_PATH}/spa-credential.json`,
  golfCredential: `${JSON_PATH}/golf-credential.json`,
  seatCredential: `${JSON_PATH}/seat-credential.json`,
  guestprofileconfig: `${JSON_PATH}/guest-profile-config.json`,
  engageprofileconfig: `${JSON_PATH}/engage-profile-config.json`,
  propertySettings: `${JSON_PATH}/property-settings.json`,
  oneCartSettings: `${JSON_PATH}/onecart-settings.json`,
  advanceFilter: `${JSON_PATH}/advancefilter-appname.json`,
  groupPermissions: `${JSON_PATH}/group-permissions-appname.json`,
  inboundSms: `${JSON_PATH}/inboundsms-appname.json`,
  languageErrorPageHint: `${JSON_PATH}/language-errorpagehint-appname.json`,
  languageProfileErrorPageHint: `${JSON_PATH}/language-profileerrorpagehint.json`,
  languages: `${JSON_PATH}/languages-appname.json`,
  onPrem: `${JSON_PATH}/onprem-appname.json`,
  onPremStay: `${JSON_PATH}/onprem-staydata-appname.json`,
  permissions: `${JSON_PATH}/permissions-appname.json`,
  propertyConfig: `${JSON_PATH}/propertyconfig-appname.json`,
  tenantpropCredentials: `${JSON_PATH}/tenantprop-credentials-appname.json`,
  tourData: `${JSON_PATH}/tourdata-appname.json`,
  giftCardConfig: `${JSON_PATH}/giftCardConfig.json`,
  printerConfig: `${JSON_PATH}/printer-config.json`,
  propertyLanguages: `${JSON_PATH}/languages.json`,
  propertyLanguagesFilePath: `${JSON_PATH}/languages`,
  upsellConfig: `${JSON_PATH}/upsell-config.json`,
  kioskConfig: `${JSON_PATH}/kiosk-config.json`,
};

export const DEFAULT_IMAGE_PATH = {
  defaultCasinoPlayerCardImage: `${IMAGE_PATH}/default-casinoplayercard.png`,
  defaultImgPlaceholder: `${IMAGE_PATH}/default-img-placeholder.jpg`,
  defaultUIImgPlaceholder: `${IMAGE_PATH}/default-ui-img-placeholder.png`,
};

export const DEFAULT_PDF_PATH = {
  bulkuploadInstruction: `${PDF_PATH}/pdf/bulkupload-instruction.pdf`,
};

export const DEFAULT_WRISTBAND_CONFIG = {
  qrCodeUrl: '',
  chargingPrivilegePathConfig: 1,
  qrCodeFormat: '<RC20,1300><QR6>',
  nameFormat: '<NR><RC70,1650><F2><HW2,3>',
  activityFormat: '<RC70,1650><F2><HW2,2>',
  activityDelimiter: ':',
  activityRowPosIncrementor: 50,
};

export const URL_CONSTANTS = {
  baseUrl: (conf: any, contentType: string) =>
    `${conf.azureStorageUrl}/${conf.appName}/${conf.tenantId}/${conf.propertyId}/images/${contentType}`,
  imagePath: (conf: any, contentType: string, encodeRoom: string) => `${URL_CONSTANTS.baseUrl(conf, contentType)}/${encodeRoom}/`,
  panoramicPath: (conf: any, contentType: string, encodeRoom: string) =>
    `${URL_CONSTANTS.baseUrl(conf, contentType)}/${encodeRoom}/panoramic/`,
  videoPath: (conf: any, contentType: string, encodeRoom: string) => `${URL_CONSTANTS.baseUrl(conf, contentType)}/${encodeRoom}/video/`,
};

export const DEFAULT_BUDDY_LIST_ORDER = [
  { label: 'Buddies', type: 'buddies' },
  { label: 'Guests', type: 'guests' },
  { label: 'Dependents', type: 'dependents' },
  { label: 'Members', type: 'members' },
];
